module.exports = __webpack_public_path__ + "static/media/create-password1.32693db3.png";